import { render, staticRenderFns } from "./FallbackModal.vue?vue&type=template&id=feb3a832&scoped=true&"
import script from "./FallbackModal.vue?vue&type=script&lang=js&"
export * from "./FallbackModal.vue?vue&type=script&lang=js&"
import style0 from "./FallbackModal.vue?vue&type=style&index=0&id=feb3a832&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb3a832",
  null
  
)

export default component.exports